// Super Admin → Website → Settings → Cookie notice.
export function CookieNoticeSettings({ value, onChange, inputCls }) {
  const v = value || {};
  const set = (k) => (e) => onChange({ ...v, [k]: e.target.type === 'checkbox' ? e.target.checked : e.target.value });
  const field = (k, label, placeholder) => (
    <div>
      <label className="block text-xs font-medium text-slate-600 mb-1">{label}</label>
      <input value={v[k] || ''} onChange={set(k)} placeholder={placeholder} className={inputCls} data-testid={`cookie-${k}`} />
    </div>
  );
  return (
    <section data-testid="cookie-notice-settings">
      <h2 className="text-sm font-semibold text-slate-900 mb-1">Cookie notice</h2>
      <p className="text-xs text-slate-500 mb-3">Shown once per visitor at the bottom of public pages until they click Accept or Decline.</p>
      <div className="flex flex-wrap gap-5 mb-3 text-sm">
        <label className="inline-flex items-center gap-2"><input type="checkbox" checked={v.enabled !== false} onChange={set('enabled')} data-testid="cookie-enabled" /> Show the notice on vyomos.io</label>
      </div>
      <p className="text-xs text-slate-500 mb-3">Academy websites use their own notice, set in each academy's Homepage Editor.</p>
      <div className="mb-4">
        <label className="block text-xs font-medium text-slate-600 mb-1">Message</label>
        <textarea rows={3} value={v.message || ''} onChange={set('message')} className={inputCls} data-testid="cookie-message" />
      </div>
      <div className="grid md:grid-cols-2 gap-4">
        {field('accept_label', 'Accept button', 'Accept')}
        {field('decline_label', 'Decline button', 'Decline')}
        {field('link_label', 'Link text', 'Privacy Policy')}
        {field('marketing_link_url', 'Link', '/privacy')}
      </div>
      <div className="flex items-center gap-3 mt-3">
        <button type="button" onClick={() => onChange({ ...v, version: (v.version || 1) + 1 })} className="text-xs px-3 py-1.5 rounded border border-slate-300 hover:bg-slate-50" data-testid="cookie-reshow">Show again to everyone</button>
        <span className="text-xs text-slate-500" data-testid="cookie-version">Version {v.version || 1}. Bumping it and saving asks every visitor again.</span>
      </div>
    </section>
  );
}
